// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { coreDao as _coreDao } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the coreDao chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1116
 * Chain Name: Core Dao
 * Default Block Explorer: https://scan.coredao.org
 * Default RPC URL: https://rpc.coredao.org
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { coreDao } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: coreDao,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const coreDao = createCommon({
	..._coreDao,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
